import type { PublicChatTheme } from './types';

export const defaultTheme: PublicChatTheme = {
  name: 'default',
  container: {
    background: 'bg-black',
    wrapper: 'size-full overflow-hidden',
    backdrop: 'bg-chat-bg-gradient',
  },
  text: {
    primary: 'text-white',
    secondary: 'text-white/40',
    accent: 'text-accent-300',
  },
  header: {
    title: 'text-white',
    subtitle: 'text-white/90',
    badge: 'bg-accent-200',
  },
  bubbles: {
    user: 'glass-bubble bg-user-bubble-gradient backdrop-blur-none md:backdrop-blur-md text-white rounded-24 max-w-[417px]',
    ai: 'glass-bubble bg-gradient-50 backdrop-blur-none md:backdrop-blur-md text-white rounded-24 max-w-[636px]',
    system: 'rounded-2xl bg-accent-200 text-center text-brand-800',
    textUser: 'font-sans text-14 font-medium leading-160 tracking-neg-2 xl:text-16',
    textAi: 'font-sans text-14 font-medium leading-160 tracking-neg-2 xl:text-16',
    timestampUser: 'text-white/60',
    timestampAi: 'text-white/60',
  },
  input: {
    wrapper: '',
    field: 'text-white placeholder:text-white/50 bg-transparent',
    placeholder: 'text-white/50',
    button: 'text-accent-300 hover:text-accent-200',
    buttonIcon: 'text-current',
  },
  branding: {
    text: 'text-white/40',
    logoFilter: 'brightness(0) invert(1) opacity(0.4)',
  },
};
